import type { Budget } from '@/types';

/**
 * Flatten a nested budget tree into individual records for IndexedDB / sealed storage.
 * API list/detail responses nest children; Dexie keys each budget by id, so children
 * must be stored as their own rows or getById(childId) fails offline.
 */
export function flattenBudgetsForStorage(budgets: Budget[]): Budget[] {
  const byId = new Map<string, Budget>();

  const visit = (node: Budget) => {
    const { children, ...rest } = node;
    byId.set(node.id, { ...rest, children: undefined });
    (children ?? []).forEach(visit);
  };

  for (const budget of budgets) {
    visit(budget);
  }

  return Array.from(byId.values());
}
